import React from "react";
import HighchartsComponent from "@ui/Highcharts";
import useOptions from "./useOptions";
import type { SelectedQuantity } from "../../useSelectedQuantities";
import type getSeries from "../Gap/getSeries";
import type { ActiveAnalysis } from "../../../../api/useActiveAnalysesStream";
import type { Project } from "../../../../api/useProjects";
import type { Source } from "../../../../api/useSources";
interface P {
  chartRef: React.RefObject<Highcharts.Chart>;
  analyses: ActiveAnalysis[];
  project: Project;
  selectedQuantities: SelectedQuantity[];
  source: Source;
  series: ReturnType<typeof getSeries>;
  timeZone: string;
}

const NormalizedGap = ({
  chartRef,
  analyses,
  project,
  source,
  series,
  selectedQuantities,
  timeZone,
}: P) => {
  const options = useOptions({
    chartRef,
    series,
    analyses,
    project,
    source,
    selectedQuantities,
    timeZone,
  });

  return (
    <HighchartsComponent
      name="Symptoms normalized gap"
      ref={chartRef}
      options={options}
      normalizeNavigatorSeries
      selectablePoints={false}
      timezone={timeZone}
    />
  );
};

export default React.memo(NormalizedGap);
